<div class="container">
  <header class="header">
    <div class="right">
      <span class="white">{{remainingTraffic}}</span>
      <span class="grey margin">{{ 'Common.Traffic.remaining' | translate }}</span>
    </div>
    <div class="left">
      <span class="grey margin-right">{{ 'Common.Traffic.notEnough' | translate }}</span>
      <button class="link" type="button" (click)="goToSubscription()">
        <span class="red margin-right-2">{{ 'Common.Traffic.buyNow' | translate }}</span>
        <svg width="10" height="14" viewBox="0 0 10 14" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M3.78385 1.56791L8.55208 6.54448C8.66846 6.66492 8.72625 6.82104 8.72625 6.97651C8.72625 7.13198 8.66846 7.28823 8.55208 7.40854L3.78385 12.3851C3.54552 12.6349 3.15 12.6431 2.90104 12.4038C2.65039 12.1662 2.64224 11.7689 2.88233 11.5207L7.25733 6.95304L2.88307 2.43224C2.64299 2.18484 2.65115 1.78692 2.90179 1.54916C3.15078 1.30984 3.54688 1.31817 3.78385 1.56791Z"
            fill="#FF3E49" />
        </svg>
      </button>
    </div>
  </header>
  <app-progress-bar [value]="progressValue" [max]="progressMax"></app-progress-bar>
  <div class="blocks">
    <div class="texts">
      <span class="white-text">{{usedTraffic}}</span>
      <span class="grey-text">{{ 'Common.Traffic.used' | translate }}</span>
    </div>
    <div class="texts">
      <span class="white-text">{{totalTraffic}}</span>
      <span class="grey-text">{{ 'Common.Traffic.total' | translate }}</span>
    </div>
  </div>
</div>